import e from"react";import{Container as t}from"./styles.js";const r=({widthSize:r="PRE_LOGIN",children:i,...o})=>e.createElement(t,{...o,ownerState:{widthSize:r}},i);export{r as default};
//# sourceMappingURL=ContentWrapper.js.map
